import React from 'react';
import { motion } from 'framer-motion';
import { Workflow, UserCheck, KeyRound, TerminalSquare, LogIn, Database } from 'lucide-react';
const CONNECTIONS = [{
  label: 'MCP',
  desc: 'Native Model Context Protocol servers',
  icon: Workflow
}, {
  label: 'Direct API',
  desc: 'First-class API integrations, not a middleman',
  icon: KeyRound
}, {
  label: 'OAuth & SSO',
  desc: 'Sign in with your existing identity provider',
  icon: LogIn
}, {
  label: 'CLIs',
  desc: 'Drive tools straight from the command line',
  icon: TerminalSquare
}, {
  label: 'Logins',
  desc: 'Securely store and use service credentials',
  icon: UserCheck
}, {
  label: 'Database credentials',
  desc: 'Query your own data sources directly',
  icon: Database
}];
export function EnterpriseConnections() {
  return <section className="w-full bg-[#FAF8F4] py-28 md:py-40 border-b border-neutral-200" data-id="element-2990" data-mp="3crslik5zeta0">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-2991" data-mp="380sqjkgfala5">
        <div className="text-center mb-16 md:mb-20" data-id="element-2992" data-mp="37z99vsquu87u">
          <span className="text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-5 block" data-id="element-2993" data-mp="18xdooan93ya1">
            Connects to everything
          </span>
          <h2 className="text-4xl md:text-5xl font-title font-bold text-[#2B211A] mb-6 tracking-tight max-w-3xl md:max-w-4xl mx-auto" data-id="element-2994" data-mp="1dyt7rx5vbups">
            Integrate deeply — your way.
          </h2>
          <p className="text-lg text-neutral-600 max-w-2xl mx-auto" data-id="element-2995" data-mp="14540az1sb69v">
            Most tools box you into OAuth alone. Giga meets your stack on its
            own terms — MCP, direct APIs, CLIs, SSO, and your own databases.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-2996" data-mp="g9rn17xl33pt">
          {CONNECTIONS.map((c, i) => {
          const Icon = c.icon;
          return <motion.div key={c.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className="bg-white rounded-2xl p-6 md:p-8 border border-neutral-200 flex items-start gap-4" data-id="element-2997" data-mp="2an92s8rqywaa" data-mpi={i}>
                <span className="w-11 h-11 rounded-xl bg-[#FFEDD5] text-[#EA580C] flex items-center justify-center shrink-0" data-id="element-2998" data-mp="246hd8s3jtxmi">
                  <Icon size={20} data-id="element-2999" data-mp="20674j7odgt3y" />
                </span>
                <div data-id="element-3000" data-mp="2wveqggswl48e">
                  <h3 className="font-bold text-[#2B211A] mb-1" data-id="element-3001" data-mp="2wvy1reo1sudg">{c.label}</h3>
                  <p className="text-sm text-neutral-600 leading-relaxed" data-id="element-3002" data-mp="2rwbox6c4tg56">
                    {c.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}